import cruise from './modules/cruise'
import user from './modules/user'
import page from './modules/page'
import booking from './modules/booking'
import partner from './modules/partner'
import review from './modules/review'
import questionnaire from './modules/questionnaire'
export default {
  page,
  user,
  cruise,
  booking,
  review,
  partner,
  questionnaire
}